module.exports = __webpack_public_path__ + "static/media/PP Rosenna Mak (Foundation)-min.9e9026ee.jpg";